var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPaylerLogo = function SvgPaylerLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 24,
    viewBox: "0 0 148 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24565 0C11.6309 0 13.6382 0.777143 15.2677 2.33143C16.8972 3.88571 17.712 5.79429 17.712 8.05714C17.712 10.32 16.8972 12.2286 15.2677 13.7829C13.6382 15.3371 11.6309 16.1143 9.24565 16.1143H4.88851V24H0V0H9.24565ZM9.24565 11.6914C10.2848 11.6914 11.1467 11.3486 11.8316 10.6629C12.5165 9.95429 12.8589 9.08571 12.8589 8.05714C12.8589 7.00571 12.5165 6.13714 11.8316 5.45143C11.1467 4.76571 10.2848 4.42286 9.24565 4.42286H4.88851V11.6914H9.24565Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3474 24L36.006 5.61039L29.4885 24H24.2103L32.8892 0H38.9467L47.661 24H42.3474Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.044 14.64L74.5457 0H69.0196L63.6351 10.0114L58.2507 0H52.7246L61.1909 14.64V24H66.044V14.64Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8614 19.4743H96.3196V24H81.9729V0H86.8614V19.4743Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.727 15.6686L142.722 24H148L142.509 14.9486C143.95 14.3086 145.107 13.36 145.981 12.1029C146.855 10.8229 147.292 9.44 147.292 7.95429C147.292 5.76 146.489 3.88572 144.883 2.33143C143.277 0.777143 141.328 0 139.038 0H129.119V24H134.008V15.6686H137.727ZM134.008 11.52V4.42286H139.038C139.959 4.42286 140.75 4.76571 141.411 5.45143C142.072 6.13714 142.403 6.97143 142.403 7.95429C142.403 8.93714 142.072 9.78286 141.411 10.4914C140.75 11.1771 139.959 11.52 139.038 11.52H134.008Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120.723 0V4.54054H104.577V0H120.723Z",
    fill: "currentColor",
    fillOpacity: 0.32
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120.723 14.2703V9.72973H104.577V14.2703H120.723Z",
    fill: "currentColor",
    fillOpacity: 0.32
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M120.723 19.4595V24H104.577V19.4595H120.723Z",
    fill: "currentColor",
    fillOpacity: 0.32
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPaylerLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "PaylerLogo.7312595dc1d39bb3f9577e72b60bf27a.svg";